import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpInterceptor, HttpRequest, HttpEvent, HttpHandler, HttpErrorResponse, HttpResponse } from '@angular/common/http'
import { Router } from '@angular/router'
import { Observable } from "rxjs";
import { tap, map } from 'rxjs/operators';
@Injectable({
  providedIn: 'root'
})
export class AuthinterceptorService implements HttpInterceptor {

  intercept(req: HttpRequest<any>,
    next: HttpHandler): Observable<HttpEvent<any>> {
    const user = localStorage.getItem("user");
    if (user) {
      var d = JSON.parse(user);
      const headers = new HttpHeaders()
        .set('x-access-token', d.idToken)
        .set('X-Content-Type-Options', 'nosniff');
      // const cloned = req.clone({
      //     headers: req.headers.set("x-access-token", d.idToken), 

      //   });
      const cloned = req.clone({
        headers: headers,

      });

      return next.handle(cloned).pipe(tap((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          // if the token is valid

          if (event.status === 401) {
            localStorage.removeItem('userData');
            this.router.navigate(['/login']);
            console.log('token expired');
          }
        }
      }, (err: any) => {
        // if the token has expired.
        if (err instanceof HttpErrorResponse) {
          if (err.status === 401) {
            // localStorage.removeItem('userData');
            this.router.navigate(['/login']);
            console.log('token expired');
          }
        }
      }));
    } else {
      return next.handle(req);
    }
  }
  constructor(private router: Router) { }

}




